import { isBrowser, toKebabCase } from '@websolutespa/bom-core';

function collectNameAndValues(object, parentKey, collection) {
  if (parentKey === void 0) {
    parentKey = '';
  }
  if (collection === void 0) {
    collection = {
      names: [],
      values: []
    };
  }
  if (object) {
    Object.entries(object).forEach(_ref => {
      let [key, value] = _ref;
      key = (parentKey.length ? `${parentKey}-` : '') + toKebabCase(key);
      if (value && typeof value === 'object') {
        collection = collectNameAndValues(value, key, collection);
      } else if (typeof value === 'string' || typeof value === 'number') {
        collection.names.push(key);
        collection.values.push(value);
      }
    });
  }
  return collection;
}
function getVars(theme, namespace) {
  if (namespace === void 0) {
    namespace = 'llm';
  }
  const nameAndValues = collectNameAndValues(theme);
  const vars = {};
  nameAndValues.names.forEach((key, i) => {
    const value = nameAndValues.values[i];
    vars[`--${namespace}-${key}`] = String(value);
  });
  return vars;
}
function createVars(vars) {
  if (isBrowser) {
    const style = `<style id="llm-style">
    /**
     * websolute - llm generated vars
     */
    .llm {
${Object.entries(vars).map(_ref2 => {
      let [k, v] = _ref2;
      return `
      ${k}: ${v};`;
    }).join('')}
    }
    </style>`;
    const styleNode = document.querySelector('#llm-style');
    if (styleNode !== null) {
      styleNode.remove();
    }
    document.head.insertAdjacentHTML('beforeend', style);
  }
}

export { createVars, getVars };
//# sourceMappingURL=vars.js.map
